module.exports = __webpack_public_path__ + "static/media/CleanRoom.3b35c593.svg";